import VueI18n from 'vue-i18n'
import Vue from 'vue'
import { BehaviorSubject } from 'rxjs';
Vue.use(VueI18n)

export type Lang = 'pl' | 'en';

export interface LangItem {
    code: Lang,
    name: string
}


interface LanguageInterface {
    mainTitle: string,
    views: {

    }
    sections: {
        [kay: string]: any
        hero: any,
        briefOffer: {
            header: string,
            description: string,
            offerList: Array<OfferListItem>
        },
        ourProjects: any,
        feauters: any,
        contactUs: any,
        affiliates: any,
        socialMedia: any,
        KeepInTouch: any,
        notFound: any,
        aboutOurProduct: any,
    },
    other: {},
    languages: LangItem[]
}

export interface OfferListItem {
    color?: string;
    dark?: boolean;

    icon: string;
    title: string;
    text: string;
    imagesNumbers: Array<number | string>;
    projectImagesNumbers: Array<number | string> | null;
    url?: {
        href: string,
        name: string
    }
}

const languages: LangItem[] = [
    {
        code: 'pl',
        name: "Polski"
    },
    {
        code: 'en',
        name: "English"
    }
]

const images = {
    doors: {
        images: [7806, 7590, 7268, 7783, 7809, 7781, 7894, 7668, 2778],
        projectImages: ["7953", "7943", "7894", "7889", "7838", "7815", "7810", "7806", "7781", "7770", "7768", "7593", "7590", "7588", "7586", "7465", "7273", "7268", "7260"]
    },

    ralings: {
        images: [8269, 7862, 7848, 8126, 8121, 7352, 7338, 301, 302],
        projectImages: ["8275", "8273", "8269", "8265", "8256", "8255", "8248", "8245", "8204", "8169", "8166", "8162", "8159", "8154", "8146", "8126", "8121", "8106", "8088", "8083", "8081", "8070", "7970", "7867", "7360", "7358", "7355", "7350", "7334", "7330"]
    },

    internal_facades: {
        images: [7782, 7168, 7187, 7219, 7260, 7584, 7735, '0001'],
        projectImages: ["7959", "7958", "7794", "7792", "7783", "7767", "7735", "7726", "7604"]
    },

    glass_building: {
        images: [7953, 7943, 7996, 2713, 7475],
        projectImages: ["8007", "7996", "7994", "7993", "7923", "7852", "7848", "7695", "7670", "7615", "7579", "7554", "7524", "7219", "7214", "7198", "7193", "7168", "7144", "7093"]
    },

    sunshades: {
        images: [7622, 7987, 7634],
        projectImages: ["7987", "7915", "7812", "7634", "7622", "7275"]
    },

    shower_cabins: {
        images: [7740, 7751, 7037, 7084, 7106, 7394, 201],
        projectImages: ["7800", "7751", "7740", "7457", "7442", "7438", "7434", "7407", "7391", "7389", "7383", "7311", "7309", "7111", "7109", "7086", "7084", "7074", "7047", "7037"]
    },

    laser_measurments: {
        images: [102, 105, 107, 111],
        projectImages: null
    }
}

const pl: LanguageInterface = {
    mainTitle: 'SOEKO - projektowanie i wykonanie architektury z szkła hartowanego',
    views: {
        home: 'Start',
        contact: 'Kontakt',
        about: 'O nas',
        offer: 'Oferta',
        projects: 'Projekty',
        404: '404',
    },
    sections: {
        hero: {
            header: "SZKŁO NA WYMIAR",
            description: `SOEKO to firma z wieloletnim doświadczeniem, istnieje na rynku od 20 lat. Początkowo zajmowała się projektowaniem i montażem konstrukcji szklanych przy dużych inwestycjach. Następnie ofertę poszerzono <span>o grupę</span> niestandardowych produktów wykonywanych na potrzeby klientów indywidualnych. Obecnie realizujemy projekty przy użyciu wszelkich formy szkła. Nasza oferta obejmuje produkty ze szkła hartowanego: płaskiego, giętego, malowanego, laminowanego. Jesteśmy <span>w stanie</span> zrealizować najbardziej skomplikowane formy obróbki szkła.`,
            mainButton: "Sprawdź naszą ofertę",
            or: "lub",
            secondButton: 'Skontaktuj się z nami'
        },
        briefOffer: {
            header: "Nasza oferta",
            description: "W naszej ofercie znajdziesz szeroki wachlarz produktów od okien przez zabudowy szklane do kabin na wymiar",
            offerList: [
                {
                    icon: 'view_carousel',
                    title: 'Drzwi',
                    text: "Drzwi szklane z szeroka gama sposobów zdobienia szkła dająca możliwość zrealizowania najbardziej wysmakowanych projektów.",
                    imagesNumbers: images.doors.images,
                    projectImagesNumbers: images.doors.projectImages
                },
                {
                    color: 'primary',
                    dark: true,
                    icon: 'calendar_view_day',
                    title: 'Balustrady',
                    text: "Podstawową cechą wykonywanych przez nas balustrad jest ich bezpieczeństwo. Wykorzystujemy najwyższej jakości materiały montażowe oraz bezpieczne hartowane szkło laminowane od najlepszych dostawców.",
                    imagesNumbers: images.ralings.images,
                    projectImagesNumbers: images.ralings.projectImages,
                },
                {
                    icon: 'store',
                    title: 'Daszki',
                    text: "Oferujemy zadaszenia ze szkła bezpiecznego, pełniące funkcję ochrony przed opadami atmosferycznymi. Są one neutralnym, a jednocześnie ozdobnym element elewacji budynków publicznych, użytkowych i prywatnych.",
                    imagesNumbers: images.sunshades.images,
                    projectImagesNumbers: images.sunshades.projectImages,
                },
                {
                    icon: 'format_paint',
                    title: 'Elewacje wewnętrzne',
                    text: "Cechy szkła jak również różnorodność jego wykończenia i zdobienia dały możliwość stosowania tego materiału w okładzinach ściennych.",
                    imagesNumbers: images.internal_facades.images,
                    projectImagesNumbers: images.internal_facades.projectImages,
                },
                {
                    icon: 'business',
                    title: 'Zabudowy szklane',
                    text: "Są to rozwiązania mające na celu otwarcie przestrzeni użytkowych. Doskonale nadaje się do budowania boksów biurowych. ",
                    imagesNumbers: images.glass_building.images,
                    projectImagesNumbers: images.glass_building.projectImages,
                },
                {
                    icon: 'fa-shower',
                    title: 'Kabiny',
                    text: "Wykonywane przez nas kabiny mogą konkurować z rozwiązaniami proponowanymi przez najlepsze firmy światowe. Proponujemy różnorodne rozwiązania konstrukcyjne, które są w stanie zaspokoić najbardziej wyszukane wizje i estetyczne potrzeby.",
                    imagesNumbers: images.shower_cabins.images,
                    projectImagesNumbers: images.shower_cabins.projectImages,
                },
                {
                    icon: 'fa-crosshairs',
                    title: 'Pomiary laserowe',
                    text: "Wykonujemy precyzyjne pomiary 2d i 3d nowoczesnym urządzeniem laserowym firmy LEICA.",
                    imagesNumbers: images.laser_measurments.images,
                    projectImagesNumbers: images.laser_measurments.images,
                    url: {
                        href: 'http://www.pomiary2di3d.pl/',
                        name: "Sprawdź"
                    }
                },
            ]
        },
        ourProjects: {
            header: "Nasza realizacje",
            description: "Oto niektóre projekty, które mieliśmy okazję zrealizować.",
        },
        feauters: {
            cards: [
                {
                    icon: 'fa-user-shield',
                    title: 'Wieloletnie doświadczenie',
                    text: 'Istniejemy na rynku od 20 lat. Mamy doświadczenie w projektowaniu i montażu konstrukcji szklanych przy dużych inwestycjach oraz projektach realizowanych na potrzeby klientów indywidualnych.',
                },
                {
                    icon: 'fa-project-diagram',
                    title: 'Szeroka oferta',
                    text: 'Obecnie realizujemy projekty przy użyciu wszelkich formy szkła hartowanego: płaskiego, giętego, malowanego, laminowanego. Jesteśmy w stanie zrealizować najbardziej skomplikowane formy obróbki szkła.',
                },
                {
                    icon: 'fa-check-double',
                    title: 'Wysoka jakość',
                    text: 'Współpracujemy z wielkimi firmami budowlanymi jak również z klientami indywidualnymi. Z równą starannością i wrażliwością, dostrzegamy duże i małe problemy.',
                },
                {
                    icon: 'fa-swatchbook',
                    title: 'Najnowsza technologia',
                    text: 'Wykonujemy montaże konstrukcji szklanych zarówno w kraju jak i zagranicą. Stworzyliśmy zaawansowane rozwiązania technologiczne dla inwestorów w Niemczech, Danii, Austrii Holandii oraz Norwegii.',
                },
            ],
        },
        contactUs: {
            header: 'Masz pytania?',
            text: 'Jeśli chcesz otrzymać odpowiedź bezpośrednio od nas, zadzwoń. Zwykle jest to najszybszy sposób na uzyskanie odpowiedzi.',
            button: "Zadzwoń"
        },
        affiliates: {
            header: "Zaufali nam",
        },
        socialMedia: {
            header: 'facebook',
            text: 'Zapraszamy na naszą stronę na facebooku',
            url: 'https://www.facebook.com/SzkloHartowaneSOEKO',
            button: "Polub nas"
        },
        KeepInTouch: {
            keepInTouch: "Dane kontaktowe",
            keepInTouchDesctibtion: "Masz dodatkowe pytania odnośnie naszej oferty? Napisz do nas lub zadzwoń.",
            mailUs: "Napisz do nas",
            adress: "Adres",
            phone: "Numer telefonu",
            email: "Email",
            form: {
                name: "Imię",
                email: "Email",
                subject: "Temat",
                message: "Wiadomość",
                sendMessage: "Wyślij wiadomość",
                sent: "Wysłano"
            },
            sentToEmail: ''
        },
        notFound: {
            pageNotExist: "Strona nie istnieje",
            back: "Zabierz mnie stąd"
        },
        aboutOurProduct: {
            header: 'O naszych produktach',
            cards: [
                {
                    title: 'Najnowsza technologia',
                    subtitle: 'Technologia',
                    text: 'Wykonujemy montaże konstrukcji szklanych zarówno w kraju jak i zagranicą. Stworzyliśmy zaawansowane rozwiązania technologiczne dla inwestorów w Niemczech, Danii, Austrii Holandii oraz Norwegii.',
                    callout: '01',
                },
                {
                    title: 'Wieloletnie doświadczenie',
                    subtitle: 'Doświadczenie',
                    text: 'Istniejemy na rynku od 20 lat. Mamy doświadczenie w projektowaniu i montażu konstrukcji szklanych przy dużych inwestycjach oraz projektach realizowanych na potrzeby klientów indywidualnych.',
                    callout: '02',
                },
                {
                    title: 'Stawiamy na jakość',
                    subtitle: 'Jakość',
                    text: 'Współpracujemy z wielkimi firmami budowlanymi jak również z klientami indywidualnymi. Z równą starannością i wrażliwością, dostrzegamy duże i małe problemy.',
                    callout: '03',
                },
            ]
        }
    },
    other: {
        showMore: 'Pokaż więcej'
    },
    languages: languages
};

const en: LanguageInterface = {
    mainTitle: 'SOEKO - design and construction of tempered glass architecture',
    views: {
        home: 'Start',
        contact: 'Contact',
        about: 'About us',
        offer: 'Offer',
        projects: 'Projects',
        404: '404',
    },
    sections: {
        hero: {
            header: "CUSTOM-MADE GLASS",
            description: `SOEKO is a company with many years of experience, it has been on the market for 20 years. Initially, she dealt with the design and assembly of glass structures for large investments. Then the offer was extended with a group of non-standard products made for the needs of individual customers. We are currently implementing projects using all forms of glass. Our offer includes products made of tempered glass: flat, bent, painted, laminated. We are able to implement the most complex forms of glass processing.`,
            mainButton: "Check our offer",
            or: "or",
            secondButton: 'Contact us'
        },
        briefOffer: {
            header: "Our offer",
            description: "In our offer, you will find a wide range of products, from windows through glass elevations to custom-made cabins",
            offerList: [
                {
                    icon: 'view_carousel',
                    title: 'Doors',
                    text: "Glass doors with a wide range of glass decorating methods that allow you to implement the most sophisticated projects.",
                    imagesNumbers: images.doors.images,
                    projectImagesNumbers: images.doors.projectImages
                },
                {
                    color: 'primary',
                    dark: true,
                    icon: 'calendar_view_day',
                    title: 'Railings',
                    text: "The basic feature of our railings is their safety. We use the highest quality assembly materials and safe toughened laminated glass from the best suppliers.",
                    imagesNumbers: images.ralings.images,
                    projectImagesNumbers:  images.ralings.projectImages,
                },
                {
                    icon: 'store',
                    title: 'Sunshades',
                    text: "We offer canopies made of safety glass that protect against rainfall. They are a neutral and at the same time decorative element of the facade of public, commercial and private buildings.",
                    imagesNumbers:  images.sunshades.images,
                    projectImagesNumbers:  images.sunshades.projectImages,
                },
                {
                    icon: 'format_paint',
                    title: 'Internal facades',
                    text: "The features of the glass as well as the variety of its finishing and decorations made it possible to use this material in wall coverings.",
                    imagesNumbers:  images.internal_facades.images,
                    projectImagesNumbers:  images.internal_facades.projectImages,
                },
                {
                    icon: 'business',
                    title: 'Glass building',
                    text: "These are solutions aimed at opening up usable spaces. Perfect for building office boxes.",
                    imagesNumbers:  images.glass_building.images,
                    projectImagesNumbers:  images.glass_building.projectImages,
                },
                {
                    icon: 'fa-shower',
                    title: 'Shower cabins',
                    text: "Our cabins can compete with the solutions proposed by the world's best companies. We offer a variety of design solutions that are able to satisfy the most sophisticated visions and aesthetic needs.",
                    imagesNumbers:  images.shower_cabins.images,
                    projectImagesNumbers:  images.shower_cabins.projectImages,
                },
                {
                    icon: 'fa-crosshairs',
                    title: 'Laser measurements',
                    text: "We perform precise 2D and 3D measurements with a modern LEICA laser device.",
                    imagesNumbers:  images.laser_measurments.images,
                    projectImagesNumbers:  images.laser_measurments.projectImages,
                    url: {
                        href: 'http://www.pomiary2di3d.pl/',
                        name: "Sprawdź"
                    }
                },
            ]
        },
        ourProjects: {
            header: "Our realizations",
            description: "Here are some projects that we have had the opportunity to implement.",
        },
        feauters: {
            cards: [
                {
                    icon: 'fa-user-shield',
                    title: 'Many years of experience',
                    text: 'We have been on the market for 20 years. We have experience in the design and assembly of glass structures for large investments and projects implemented for the needs of individual clients.',
                },
                {
                    icon: 'fa-project-diagram',
                    title: 'Wide offer',
                    text: 'Currently, we implement projects using all forms of tempered glass: flat, bent, painted, laminated. We are able to implement the most complex forms of glass processing.',
                },
                {
                    icon: 'fa-check-double',
                    title: 'High quality',
                    text: 'We work with large construction companies as well as with individual clients. With equal care and sensitivity, we spot big and small problems.',
                },
                {
                    icon: 'fa-swatchbook',
                    title: 'Latest technology',
                    text: 'We assemble glass structures both in Poland and abroad. We have created advanced technological solutions for investors in Germany, Denmark, Austria, the Netherlands and Norway.',
                },
            ],
        },
        contactUs: {
            header: 'Do you have any questions?',
            text: 'If you want an answer directly from us, call us. This is usually the fastest way to get an answer.',
            button: "Call us"
        },
        affiliates: {
            header: "Trust us",
        },
        socialMedia: {
            header: 'facebook',
            text: 'Please visit our facebook page',
            url: 'https://www.facebook.com/SzkloHartowaneSOEKO',
            button: "like us"
        },
        KeepInTouch: {
            keepInTouch: "Contact details",
            keepInTouchDesctibtion: "Do you have additional questions about our offer? Write to us or call us.",
            mailUs: "Write to us",
            adress: "Address",
            phone: "Phone number",
            email: "Email",
            form: {
                name: "Name",
                email: "Email",
                subject: "Subject",
                message: "Message",
                sendMessage: "Send Message",
                sent: "Message was sent"
            },
            sentToEmail: ''
        },
        notFound: {
            pageNotExist: "Page does not exist",
            back: "Get me out of here"
        },
        aboutOurProduct: {
            header: 'About our products',
            cards: [
                {
                    title: 'The latest technology',
                    subtitle: 'Technology',
                    text: 'We assemble glass structures both in Poland and abroad. We have created advanced technological solutions for investors in Germany, Denmark, Austria, the Netherlands and Norway.',
                    callout: '01',
                },
                {
                    title: 'Many years of experience',
                    subtitle: 'Experience',
                    text: 'We have been on the market for 20 years. We have experience in the design and assembly of glass structures for large investments and projects implemented for the needs of individual clients.',
                    callout: '02',
                },
                {
                    title: 'We focus on quality',
                    subtitle: 'Quality',
                    text: 'We work with large construction companies as well as with individual clients. With equal care and sensitivity, we spot big and small problems.',
                    callout: '03',
                },
            ]
        }
    },
    other: {
        showMore: 'Show more'
    },
    languages: languages
};

export const messages = {
    pl: pl,
    en: en
}

export class TranslationsService {

    public readonly selsectedLanguage$: BehaviorSubject<Lang | null> = new BehaviorSubject(null as any);

    public readonly i18n: VueI18n | undefined
    defaultLang: Lang = 'pl'
    supportedLanugaes: Lang[] = ['pl', 'en']

    public constructor() {
        const lang = this.getLang();
        this.i18n = new VueI18n({ locale: lang, messages: (messages as any) });
        this.selsectedLanguage$.next(lang);
        console.log(this.getLang(), 'lang detected')
    }

    getMessages(): typeof messages.pl {
        const lang = this.selsectedLanguage$.getValue() ?? this.getLang();
        return messages[lang] ?? messages[this.defaultLang];
    }

    translate(key: string): string {
        return this.i18n?.t(key) as string
    }

    setLang(lang: Lang) {
        if (this.i18n) {
            this.i18n.locale = lang as any;
            this.selsectedLanguage$.next(lang);
        }
    }

    getLang(): Lang {
        let lang = navigator.language as Lang
        if (lang.includes('-')) {
            lang = lang.split('-')[0] as Lang
        };
        return this.supportedLanugaes.includes(lang) ? lang : this.defaultLang;
    }

}

export default new TranslationsService()

